module.exports = __webpack_public_path__ + "img/title_top.13f47438.png";